<app-header-breadcrumb></app-header-breadcrumb>
<p class="tituloSeccion">Evolución de los pagos netos</p>

<!--<p-chart id="myChart" type="line" [data]="data" [options]="options" width="100vw" height="30vh"></p-chart>

<br/>-->

<p-chart type="bar" [data]="data_anual" [options]="options2" width="95vw" height="30vh"></p-chart>

